import { ChartFilter } from '/src/lib/types';

/**
 * Filter
 */

export type FilterProps = ChartFilter;

export class Filter implements FilterProps {
  name: string;

  constructor(name: string) {
    this.name = name;
  }
}
